module.exports = __webpack_public_path__ + "img/dentures-and-prosthodontics.a6b3f73a.svg";